import { zodResolver } from '@hookform/resolvers/zod';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { CampaignSummarySection } from './CampaignSummarySection';
import { CampaignsProvider } from './context';
import { CreateCampaignContent } from './CreateCampaignContent';
import { CREATE_CAMPAIGN_FORM_SCHEMA, CreateCampaignFormInput, CreateCampaignFormOutput } from './validation';
import { RootState, useAppDispatch } from '@/reducers';
import { useSelector } from 'react-redux';
import { reset } from '../../campaignsSlice';

export const CreateCampaignV2: FC = () => {
  const methods = useForm<CreateCampaignFormInput, unknown, CreateCampaignFormOutput>({
    resolver: zodResolver(CREATE_CAMPAIGN_FORM_SCHEMA),
    defaultValues: {
      name: '',
      description: '',
      createdDataSources: [],
      connectors: [],
      audience: null,
    },
  });

  const dispatch = useAppDispatch();

  const createState = useSelector((state: RootState) => state.campaigns.create);
  if (!createState?.audiences) {
    dispatch(reset());
  }

  return (
    <CampaignsProvider>
      <FormProvider {...methods}>
        <form className='flex size-full'>
          <CampaignSummarySection />
          <CreateCampaignContent />
        </form>
      </FormProvider>
    </CampaignsProvider>
  );
};
